module.exports = __webpack_public_path__ + "img/chevron_right.9253e102.svg";